import { RemoteGuides } from 'types/contentful'

import css from './PostCard.module.css'

export type PostCardProps = {
    post: RemoteGuides.Post
    featuredPost: RemoteGuides.Post
}

function PostCard({ post, featuredPost }: PostCardProps) {
    const { slug, title, description, thumbnailImage } = post

    return (
        <a
            href={`/remote-work-guides/${slug}`}
            className={`${css.postCard} ${featuredPost ? css.featuredPost : ''}`}
            aria-label={title}
        >
            <img
                className={featuredPost ? css.featuredThumbnail : undefined}
                src={thumbnailImage.url}
                alt=""
            />

            <div>
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        </a>
    )
}

export default PostCard
